"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var react_1 = __importStar(require("react"));
var Dropdown_1 = require("../Dropdown");
var Pane_1 = require("../Pane");
var Select = function (_a) {
    var options = _a.options, label = _a.label, defaultValue = _a.value, onChange = _a.onChange, rest = __rest(_a, ["options", "label", "value", "onChange"]);
    var _b = __read((0, react_1.useState)(defaultValue), 2), value = _b[0], setValue = _b[1];
    var selectedOption = options.find(function (option) { return option.value === value; });
    (0, react_1.useEffect)(function () {
        setValue(defaultValue);
    }, [defaultValue]);
    var handleSelect = function (selectedValue) {
        setValue(selectedValue);
        onChange && onChange(selectedValue);
    };
    return (react_1.default.createElement(Dropdown_1.Dropdown, __assign({ label: [label, selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label].filter(Boolean).join(": ") }, rest), function (_a) {
        var handleClose = _a.handleClose;
        return options.map(function (option) {
            return (react_1.default.createElement(Pane_1.PaneOption, { key: [option.label, option.value].join(":"), onClick: function () {
                    handleSelect(option.value);
                    handleClose();
                } }, option.label));
        });
    }));
};
exports.Select = Select;
exports.Select.displayName = "Select";
//# sourceMappingURL=Select.js.map